import { Action } from '@ngrx/store';
import { TNavigationState } from './navigation.models';

export const NavigationInfoActionType = {
  SelectNavigationItem: 'SELECT_NAVIGATION_ITEM' as const,
  SetCustomPageHeader: 'SET_CUSTOM_PAGE_HEADER' as const,
  SetSelectedFactoryIds: 'SET_SELECTED_FACTORY_IDS' as const,
};

export class SelectNavigationItem implements Action {
  readonly type = NavigationInfoActionType.SelectNavigationItem;
  constructor(public payload: TNavigationState['navigationTreeList'][number]) {}
}

export class SetCustomPageHeader implements Action {
  readonly type = NavigationInfoActionType.SetCustomPageHeader;
  constructor(public payload: string | null) {}
}

export class SetSelectedFactoryIds implements Action {
  readonly type = NavigationInfoActionType.SetSelectedFactoryIds;
  constructor(public payload: string[]) {}
}

export type TNavigationActions = SelectNavigationItem | SetCustomPageHeader | SetSelectedFactoryIds;
